import { render, staticRenderFns } from "./RemarksAndMortgages.vue?vue&type=template&id=d36ebdb2"
import script from "./RemarksAndMortgages.vue?vue&type=script&lang=ts"
export * from "./RemarksAndMortgages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports